import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface AdminStats {
  totalProperties: number;
  activeProperties: number;
  totalLeads: number;
  newLeads: number;
  totalViews: number;
  featuredProperties: number;
}

export function useAdminStats() {
  return useQuery({
    queryKey: ['admin-stats'],
    queryFn: async (): Promise<AdminStats> => {
      // Get property stats
      const { data: properties, error: propError } = await supabase
        .from('properties')
        .select('id, status, is_featured, views_count');

      if (propError) throw propError;

      // Get lead stats
      const { data: leads, error: leadError } = await supabase
        .from('leads')
        .select('id, status');

      if (leadError) throw leadError;

      const totalProperties = properties?.length || 0;
      const activeProperties = properties?.filter(p => p.status === 'disponivel').length || 0;
      const featuredProperties = properties?.filter(p => p.is_featured).length || 0;
      const totalViews = properties?.reduce((acc, p) => acc + (p.views_count || 0), 0) || 0;

      const totalLeads = leads?.length || 0;
      const newLeads = leads?.filter(l => l.status === 'novo').length || 0;

      return {
        totalProperties,
        activeProperties,
        totalLeads,
        newLeads,
        totalViews,
        featuredProperties,
      };
    },
  });
}
